// graphics-generator.ts - Frontend version using nhost.functions.call
import { captureException } from '@sentry/browser';
import { nhost } from 'Providers/nhost/NhostProvider.tsx';

export interface SingleMetricScore {
  total: number | null;
  eligible: number | null;
  aligned: number | null;
  inProgress?: number | null;
  enabling?: number | null;
  transitional?: number | null;
}

export interface FullScoreData {
  Turnover: SingleMetricScore;
  CapEx: SingleMetricScore;
  OpEx: SingleMetricScore;
}

export interface GraphicsTableData {
  companyName: string;
  reportingYear: number;
  currency: string;
  fullScore: FullScoreData;
}

interface ExcelResponse {
  success: boolean;
  file: string; // base64 encoded Excel file
  filename: string;
  mimeType: string;
}

export const generateGraphicsTable = async (data: GraphicsTableData) => {
  try {
    console.log(`Generating Excel charts for: ${data.companyName}`);

    // Use nhost.functions.call like your other functions
    const result = await nhost.functions.post<ExcelResponse>('/generate-graphics-excel', data);

    if (!result.body?.success) {
      throw new Error('Failed to generate Excel file');
    }

    const { file, filename, mimeType } = result.body;
    // Convert base64 to blob
    const binaryString = atob(file);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: mimeType });

    // Create download link and trigger download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    console.log('Excel file with native charts downloaded successfully!');
  } catch (error) {
    console.error('Error generating graphics table:', error);
    captureException(error);

    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    alert(
      `Failed to generate Excel file with charts: ${errorMessage}. Please try again or contact support.`
    );
  }
};
